import { ref, computed, watch } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment-timezone";
import store from "@/store";
import ability from "@/libs/acl/ability";
import useFilterCounter from "@/components/Filters/useFiltersCount";
import { debounce } from "lodash"

export default function useList() {
  const refListTable = ref(null);

  const toast = useToast();

  store.dispatch('tenant/getAll')
  const tenantOptions = computed(() => store.getters['tenant/getSelectedItems'])
  const tenantFilter = ref(null)


  store.dispatch('ntechlab_watch_list/getAll')
  const watchlistOptions = computed(() => store.getters['ntechlab_watch_list/getSelectedItems'])
  const watchlistFilter = ref(null)
  const tableColumns = [
    { label: "ntechlab.face.image", key: "image_url", sortable: true },
    { label: "ntechlab.face.name", key: "name", sortable: true },
    { label: 'ntechlab.face.active', key: 'active', sortable: true },
    { label: "ntechlab.face.comment", key: "comment", sortable: true },
    { label: 'ntechlab.face.master_account', key: 'master_account_name', sortable: true },
    {
      label: 'ntechlab.face.watch_list',
      key: 'watch_lists',
      sortable: true,
      formatter: (value) => value.map(list => list.name).join(', ')
    },
    { label: 'ntechlab.face.features', key: 'features', sortable: false },
    { label: 'date.created_at', key: 'created_at', sortable: true, formatter: 'formatDateAssigned' },
    { label: 'date.updated_at', key: 'updated_at', sortable: true, formatter: 'formatDateAssigned' },
  ];
  if (
    ability.can("update", "NtechlabFace") == true ||
    ability.can("delete", "NtechlabFace") == true
  ) {
    tableColumns.splice(0, 0, { label: "actions.name", key: "actions" });
  }

  const perPage = ref(10);
  const totalList = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    };
  });

  const fetchList = (ctx, callback) => {
    store
      .dispatch("ntechlab_face/getAll", {
        q: searchQuery.value,
        max: perPage.value,
        "page[n]": currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        master_account: watchlistFilter.value,
      })
      .then((response) => {
        callback(response.data);
        totalList.value = response.meta.total;
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error obteniendo la información",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const formatDateAssigned = (value) => {
    const formattedDate = moment(value).format("DD/MM/YYYY HH:mm:ss");
    return formattedDate;
  };

  const refetchData = () => {
    refListTable.value.refresh();
  };

  watch([
    currentPage,
    perPage,
  ], () => {
    refetchData();
  });

  watch([ searchQuery ], debounce(() => { refetchData() }, 500))

  // filters counter ============================
  const filters = ref({});
  const filtersCount = useFilterCounter(filters);
  const buildFilters = () => {
    filters.value = {
      master_account: watchlistFilter.value,
    };
    refetchData();
  }
  const clearSearchFilters = () => {
    watchlistFilter.value = null;
    buildFilters();
  }
  // ============================================

  return {
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    formatDateAssigned,
    tenantOptions,
    tenantFilter,
    refetchData,
    watchlistOptions,
    watchlistFilter,
    filtersCount,
    buildFilters,
    clearSearchFilters,
  };
}
